if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.optionButtons = this.querySelectorAll('variant-option');
      this.optionButtons.forEach( 
        (button) => button.addEventListener('click', this.onProductChange.bind(this))
      );
      // if no options, set to 0
      if (this.optionButtons.length != 0 ) {
        this.variants = this.getVariantData();
        this.numOptions = this.variants[0].options.length; // gets the number of options to determine form logic
      } else {
        this.numOptions = 0;
      }

      this.option1 = null;
      this.option2 = null;
      this.option3 = null;

      this.currentVariant = null;
      
      this.updateOptionOne();

      this.checkDeepLink()
      
    }

    checkDeepLink() {
      if (window.location.search.includes('variant') && this.numOptions > 0 ) {
        const variantId = window.location.search.split('=')[1];

        const variantMatch = this.variants.find(variant => variant.id == variantId );

        // set option values
        this.option1 = variantMatch.option1;
        this.option2 = variantMatch.option2;
        this.option3 = variantMatch.option3;

        // remove disabled class from option groups
        const optionGroups = document.querySelectorAll('.product_option-container');
        optionGroups.forEach(function(optionGroup) {
          optionGroup.classList.remove('disabled');
        })

        // enable options for selected variant
      
        // this was here to deal with ship dates added to variants, commenting out
        // var cleanValueTwo, cleanValueThree;
        // if(variantMatch.option2 != null ) {
        //   cleanValueTwo = variantMatch.option2.split(" - ")[0];
        // }
        // if(variantMatch.option3 != null ) {
        //   cleanValueThree = variantMatch.option3.split(" - ")[0];
        // }

        const allOptions = Array.from(this.optionButtons);
        const option1Buttons = allOptions.filter(option => option.dataset.position == 1);
        const option2Buttons = allOptions.filter(option => option.dataset.position == 2);
        const option3Buttons = allOptions.filter(option => option.dataset.position == 3);

        option1Buttons.forEach(function(option) {
          if ( option.dataset.value == variantMatch.option1 ) {
            option.selectOption();
          }
        })
        option2Buttons.forEach(function(option) {
          if ( option.dataset.value == variantMatch.option2 ) {
            option.enableOption();
            option.selectOption();
          }
        })
        option3Buttons.forEach(function(option) {
          if ( option.dataset.value == variantMatch.option3 ) {
            if ( option.dataset.name.includes('Select Your Color') ) {
              document.querySelector('.product_option-label.color-label').innerHTML = option.dataset.value;
            }
            option.enableOption();
            option.selectOption();
          }
        })

        // update master select and such
        this.updateProduct();
      }
    }

    updateOptionOne() {
      // called when form loads and one of the first options is selected
      
      // if no variants, prep form, otherwise go through option selection process 
      if ( this.numOptions == 0 ) {
        this.currentVariant = this.getVariantData()[0];
        this.setShipDate();
        this.updateMasterSelect();
      } else {
        this.querySelector('product-form').disableButton();
        const el = this;
        const allOptions = Array.from(this.optionButtons);
        const allVariants = this.variants;

        const option1Buttons = allOptions.filter(option => option.dataset.position == 1);
        const option2Buttons = allOptions.filter(option => option.dataset.position == 2);
        const option3Buttons = allOptions.filter(option => option.dataset.position == 3);

        
        // find variants containing the currently selected option
        option1Buttons.forEach(function(option) {
          const variantsWithOption = allVariants.filter(variant => variant.option1 == option.dataset.value);
          // check if the option has at least one variant available, if so remove the disabled class that loads by default
          variantsWithOption.forEach(function(variant) {
            if ( variant.available ) {
              option.enableOption();
            }
          })

          if(option.classList.contains('selected')) {
            // if there is only one option, update the variant with the option, otherwise update option 2 buttons
            if ( el.numOptions == 1 ) {
              el.updateProduct();
            } else {
              // loop through option 2 buttons and enable any that are available with the currently selected option 1
              option2Buttons.forEach(function(option2) {
                option2.hideOption();
                const buttonValue = option2.dataset.value;
                variantsWithOption.forEach(function(variant) {
                  if ( variant.available ) {
                    let cleanValue = variant.option2;
                    if ( option2.dataset.name.includes("color") || option2.dataset.name.includes("Color") ) {
                      cleanValue = variant.option2.split(" - ")[0];
                    }
                    if ( cleanValue == buttonValue ) {
                      option2.enableOption();
                    }
                  }
                })
              })
            }
          }
        })
      }
    }

    updateOptionTwo() {
      // called when a level 2 option is selected
      const el = this;
      const allOptions = Array.from(this.optionButtons);
      const allVariants = this.variants;

      const option2Buttons = allOptions.filter(option => option.dataset.position == 2);
      const option3Buttons = allOptions.filter(option => option.dataset.position == 3);

      // find variants containing the currently selected option
      option2Buttons.forEach(function(option) {
        // option.hideOption();
        if ( option.classList.contains('selected' ) ) {
          const variantsWithOption = allVariants.filter(variant => variant.option1 == el.option1 && variant.option2 == option.dataset.value);
          variantsWithOption.forEach(function(variant) {
            if ( variant.available ) {
              option.enableOption();
            }
          })

          // if there are two options, update the variant with the option, otherwise update option 3 buttons
          if ( el.numOptions == 2 ) {
            el.updateProduct();
          } else {
            // loop through option 3 buttons and enable any that are available with the currently selected option 1 and option 2
            option3Buttons.forEach(function(option3) {
              option3.hideOption();
              const buttonValue = option3.dataset.value;
              variantsWithOption.forEach(function(variant) {
                if ( variant.available ) {
                  let cleanValue = variant.option3;
                  if ( option3.dataset.name.includes("color") || option3.dataset.name.includes("Color") ) {
                    cleanValue = variant.option3.split(" - ")[0];
                  }
                  if ( cleanValue == buttonValue ) {
                    option3.enableOption();
                  }
                }
              })
            })
          }
        }
      });
    }

    onProductChange() {
      const optionButton = event.currentTarget
      // ignores click if the button is disabled
      if( optionButton.classList.contains('disabled') ) {
        return;
      } else {
        // otherwise calls appropriate functions based on option position
        // option 1 click resets everything, option 2 click resets option 3, etc.
        if( optionButton.dataset.position == 1 ) {
          this.clearAllOptions(1);
          optionButton.selectOption();
          this.option1 = optionButton.dataset.value;
          this.updateOptionOne();
          if (this.numOptions == 2 ) { 
            this.querySelector('.product_option-container.option-set-2').classList.remove('disabled');
          }
          if (this.numOptions == 3 ) { 
            this.querySelector('.product_option-container.option-set-2').classList.remove('disabled');
            this.querySelector('.product_option-container.option-set-3').classList.add('disabled');
          }
        } else if( optionButton.dataset.position == 2 ) {
          this.clearAllOptions(2);
          optionButton.selectOption();
          this.option2 = optionButton.dataset.value;
          this.updateOptionTwo();
          if (this.numOptions == 3 ) { 
            this.querySelector('.product_option-container.option-set-3').classList.remove('disabled');
          }
        } else if( optionButton.dataset.position == 3 ) {
          this.clearAllOptions(3);
          optionButton.selectOption();
          this.option3 = optionButton.dataset.value;
          this.updateProduct();
        }
      }
    }

    clearAllOptions(level) {
      // clears options and adds disabled back. accepts 1, 2 or 3 as value based on which option was changed
      this.querySelector('product-form').disableButton();
      const allOptions = Array.from(this.optionButtons);
      // const optionsToClear = allOptions.filter(option => option.dataset.position == level );
      allOptions.forEach( function(option) {
        if(level == 1) {
          option.unselectOption();
          option.disableOption();
        } else if ( level == 2 ) {
          if ( option.dataset.position == 2 || option.dataset.position == 3 ) {
            option.unselectOption();
            // option.disableOption();
          }
        } else if ( level == 3 ) {
          if ( option.dataset.position == 3 ) {
            option.unselectOption();
          }
        }
      })

      // clear variant selection in browser bar
      const currentURL = window.location.href.split('?variant=')[0];
      history.pushState({}, document.title, `${currentURL}`)

    }

    updateProduct() {
      this.updateVariant();
      this.updateMasterSelect();
      this.updateProductInfo();
    }

    updateVariant() {
      const el = this;
      // finds the variant that matches all currently set options
      this.currentVariant = this.variants.find((variant) => {
        return variant.option1 == el.option1 && variant.option2 == el.option2 && variant.option3 == el.option3;
      });
    }

    updateMasterSelect() {
      if (this.currentVariant != null ) {
        // updates the master select object that is passed to cart on submit
        const select = this.querySelector('#product-select');
        select.value = this.currentVariant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        // enable purchase button if product in stock or preorder, pass variable for preorder or not based on available inventory
        if ( this.currentVariant.inventory_quantity > 0 || this.currentVariant.inventory_management == null ) {
          this.querySelector('product-form').enableButton(false);
        } else if (this.currentVariant.inventory_quantity <= 0 && this.currentVariant.inventory_policy == 'continue' ) {
          this.querySelector('product-form').enableButton(true);        
        }
        // update URL in browser to reflect selected variant
        if ( !window.location.href.includes('?variant=') && this.numOptions != 0 ) {
          const currentURL = window.location.href;
          history.pushState({}, document.title, `${currentURL}?variant=${this.currentVariant.id}`)
        }
      }
    }

    updateProductInfo() {
      // update price
      if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
        this.querySelector('.product-price').innerHTML = `<span class="sale-price_new">$${(this.currentVariant.price / 100).toFixed(2)}</span> &nbsp;<span class="sale-price_old">${(this.currentVariant.compare_at_price / 100).toFixed(2)}</span>`;
      } else {
        this.querySelector('.product-price').innerHTML = `$${(this.currentVariant.price / 100).toFixed(2)}`;
      }
      // images
      if ( this.currentVariant.featured_image ) {
        const currentSlide = document.querySelector('.product-header-swiper .swiper-slide-active');
        currentSlide.querySelector('img').src = this.currentVariant.featured_image.src;
      }

      // update ship date for backorder
      this.setShipDate();
    }

    setShipDate() {
      // ship date metafield
      const el = this;
      const availableQuantity = el.currentVariant.inventory_quantity;

      const fenix = document.querySelector('.fenix-message');
      document.querySelectorAll('.variant-ship-dates div').forEach(function(variant) {
        if ( variant.dataset.variant == el.currentVariant.id ) {
          if ( variant.dataset.shipdate && availableQuantity <= 0 ) {
            document.querySelector('.product-ship-date').innerHTML = `<strong>Preorder now!</strong> Estimated ship date ${variant.dataset.shipdate}!`;
            document.querySelector('#shipdate').value = variant.dataset.shipdate;
            fenix ? fenix.classList.add('visually-hidden') : null;
          } else if ( variant.dataset.defaultshipdate && availableQuantity <= 0 ) {
            document.querySelector('.product-ship-date').innerHTML = `<strong>Preorder now!</strong> Estimated ship date ${variant.dataset.defaultshipdate}!`;
            document.querySelector('#shipdate').value = variant.dataset.defaultshipdate;
            fenix ? fenix.classList.add('visually-hidden') : null;
          } else if (availableQuantity > 0) {
            document.querySelector('.product-ship-date').innerHTML = `<strong>In stock!</strong> Order by 3:00PM EST for same day shipping!`;
            document.querySelector('#shipdate').value = 'In Stock';
            fenix ? fenix.classList.remove('visually-hidden') : null;
          }
        }
      })
    }

    getVariantData() {
      // returns parsed json data containing all the product variants - stored in each product option button
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }  
  });
}